module.exports = __webpack_public_path__ + "img/house_01.c6a3092d.jpg";